<template>
  <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <!-- <H2 style="margin-bottom: 40px">文章类型</H2> -->
        <a-form>
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="类型名称" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="">
                <a-input v-model="table.search.typeName" placeholder="请输入文章类型名称" />
              </a-form-item>
            </a-col>
            <a-col :md="8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="{ float: 'left', overflow: 'hidden' } || {}">
                <a-button type="primary" @click="toSearch">查询</a-button>
                <a-button style="margin-left: 8px; font-style: italic" @click="resetSearch">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator" style="margin-top: 20px">
        <a-button type="primary" icon="plus" @click="createType">新增类型</a-button>
      </div>
      <a-spin tip="加载中..." :spinning="table.loading">
        <!-- 表格 -->
        <a-table :columns="columns" :data-source="table.data" rowKey="id" :pagination="table.page"
          @change="handlePageChange">
          <span slot="status" slot-scope="data">
            <div>
              <a-switch :checked="data.status == 1" @change="setnewsTypeStatus(data)" />
            </div>
          </span>
          <span slot="action" slot-scope="text, data">
            <template>
              <a @click="handleEdit(data)">编辑</a>
              <a-divider type="vertical" />
              <a @click="handleDelete(data)">删除</a>
            </template>
          </span>
        </a-table>
      </a-spin>

      <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal"
        destroy-on-close centered>
        <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
          <a-form-model-item label="类型名称">
            <a-input v-model="form.typeName"></a-input>
          </a-form-model-item>
          <a-form-model-item label="类型说明">
            <a-input v-model="form.description"></a-input>
          </a-form-model-item>
          <a-form-model-item label="类型说明" v-if="modal.type == 1">
            <a-radio-group v-model="form.status">
              <a-radio :value="1">显示</a-radio>
              <a-radio :value="0">隐藏</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import NewsCategoryService from "@/io/news/newsCategory.js";

export default {
  name: "newstype",
  data() {
    let self = this;
    return {
      resCategoryData: {
        data: [
          {
            id: 5,
            name: "游戏",
            remarks: "游戏文章类型",
            status: 1,
            created_at: "2022-03-29 10:48:31",
          },
          {
            id: 4,
            name: "育儿",
            remarks: "育儿文章类型",
            status: 1,
            created_at: "2022-03-29 10:48:24",
          },
          {
            id: 3,
            name: "旅游",
            remarks: "旅游文章类型",
            status: 1,
            created_at: "2022-03-29 10:48:18",
          },
          {
            id: 2,
            name: "健康",
            remarks: "健康文章类型",
            status: 1,
            created_at: "2022-03-29 10:48:10",
          },
          {
            id: 1,
            name: "生活",
            remarks: "生活文章类型",
            status: 1,
            created_at: "2022-03-29 10:47:46",
          },
        ],
        meta: {
          pagination: {
            total: 5,
            count: 5,
            per_page: 15,
            current_page: 1,
            total_pages: 1,
            links: [],
          },
        },
      },
      // create model
      modal: {
        title: '新增类型',
        show: false,
        loading: false,
        // 0新增，1编辑
        type: 0,
      },
      rules: {},
      form: {
        typeName: null,
        description: null,
        id: null,
        status: 1
      },

      queryParam: {},
      columns: [
        {
          title: "类型名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "备注",
          dataIndex: "remarks",
          key: "remarks",
        },
        {
          title: "状态",
          key: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      table: {
        editData: {
          typeName: null,
          description: null,
        },
        loading: false,
        data: [],
        search: {
          typeName: null,
        },
        page: {
          total: 10,
          current: 1,
          pageSize: 10,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal() {
            return `共${self.table.page.total}条`;
          },
        },
      },
    };
  },
  mounted() {
    this.getTypeList();
  },
  methods: {
    //   获取类型列表
    async getTypeList() {
      this.table.loading = true;
      const { page, search } = this.table;
      const res = await NewsCategoryService.list(
        search.typeName,
        page.current
      );
      // const res = this.resCategoryData
      this.table.data = res.data;
      this.table.page.total = res.meta.pagination.total;
      this.table.loading = false;
    },
    //   更改状态
    async setnewsTypeStatus({ id, status }) {
      console.log(id)
      let resStatus = status == '1' ? '0' : '1'
      const res = await NewsCategoryService.status(id)
      let index = this.table.data.findIndex((val) => {
        return val.id == id
      })
      this.table.data[index].status = resStatus
    },
    // 编辑
    handleEdit(data) {
      this.modal.type = 1
      this.modal.show = true
      this.form.typeName = data.name
      this.form.description = data.remarks
      this.form.id = data.id
    },
    // 新建
    createType() {
      this.modal.type = 0
      this.modal.show = true;
      this.form.typeName = null
      this.form.description = null
      this.form.id = null
    },
    // 提交
    confirmModal() {
      this.$beforeFormSubmit(this.$refs.form, async () => {
        let { id, typeName, description, status } = this.form
        this.modal.loading = true;
        // 新增
        console.log(this.modal.type)
        if (this.modal.type == 0) {
          await NewsCategoryService.add(typeName, description, 1);
          this.$afterFormSubmit("创建成功", () => {
            this.getTypeList();
            this.modal.show = false;
            this.modal.loading = false
          });
        } else {
          await NewsCategoryService.edit(id, typeName, description, status);
          this.$afterFormSubmit("修改成功", () => {
            this.getTypeList();
            this.modal.show = false;
            this.modal.loading = false
          });
        }
      });
    },
    // 删除类型
    async handleDelete({ id }) {
      const res = await NewsCategoryService.delete(id);
      this.$message.info(res.msg);
      this.getTypeList();
    },
    handlePageChange(page) {
      this.table.page.current = page.current;
      this.table.page.pageSize = page.pageSize;
      this.getTypeList();
    },
    // 搜索
    toSearch() {
      this.table.page.current = 1;
      this.getTypeList();
    },
    // 重置
    resetSearch() {
      this.table.search.typeName = null;
    },
  },
};
</script>
